/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Linesheet_Name_TakenInputs */

const en_error_linesheet_name_taken = /** @type {(inputs: Error_Linesheet_Name_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You already have a linesheet with this name. Choose another name.`)
};

/**
* | output |
* | --- |
* | "You already have a linesheet with this name. Choose another name." |
*
* @param {Error_Linesheet_Name_TakenInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_linesheet_name_taken = /** @type {((inputs?: Error_Linesheet_Name_TakenInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Linesheet_Name_TakenInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_linesheet_name_taken(inputs)
});